import React, {  useCallback, useEffect, useMemo, useState  } from 'react'
import { Breadcrumb, CardBasic, ModalForm, ModalInfo, SButton, TabCard, TextInput } from '../../components'
import { Ceklis, Medic1, Silang, CekSuccess, Health } from '../../assets'
import { Image } from 'react-bootstrap'
import ShowAlert from '../../components/ShowAlert';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { API_BASE_URL } from '../../config';

function Pos() {
    const [showModal, setShowModal] = useState(false);
    const [fields, setFields] = useState([]);
   
    //alert
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [loadingCategory, setLoadingCategory] = useState(true);
    const [loadingModal, setLoadingModal] = useState(false);

    const [dataPatient, setDataPatient] = useState([]);
    const [pasien, setPasien] = useState([]);

    // category
    const [categoryTreatmentData, setCategoryTreatmentData] = useState([]);
    const [categoryProductData, setCategoryProductData] = useState([]);
    const [categoryObatData, setCategoryObatData] = useState([]);

    //modal
    const [showAddWorkerModal, setShowAddWorkerModal] = useState(false);
    const [selectedOrderItem, setSelectedOrderItem] = useState(null);
    const [showDepositHistoryModal, setShowDepositHistoryModal] = useState(false);
    const [depositHistory, setDepositHistory] = useState([]);

    //select option
    const [therapisOpt, setTherapisOpt] = useState([]);
    const [dokterOpt, setDokterOpt] = useState([]);
        
    const user = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state ? location.state : user.user;
    const fromRegistration = Array.isArray(data?.from) && data.from[0]?.label === 'Registration';
    const savedDoctorReview = useMemo(() => (
        location.state ? dataPatient?.data?.data?.treatment_patient : []
    ), [location.state, dataPatient]);

    const [orderItems, setOrderItems] = useState(() => {
        const saved = localStorage.getItem("orderItems");
        const initialValue = JSON.parse(saved) || [];
        const pasienData = location.state ? data : pasien?.data?.patient || [];
        if (data?.no_medical_record && data?.no_regist && data?.klinik_id) {
            return initialValue.filter(item =>
                item.no_medical_record === data.no_medical_record &&
                item.no_regist === data.no_regist &&
                item.klinik_id === data.klinik_id
            );
        }else if(pasienData?.no_medical_record && pasienData?.klinik_id){
             return initialValue.filter(item =>
                item.no_medical_record === pasienData.no_medical_record &&
                item.klinik_id === pasienData.klinik_id
            );
        }
        return [];
    });

    const headerPatient =  useCallback( async () => {
        try {
            const token = localStorage.getItem('access_token');
            let url = '';
            if(location.state === null){
                url = `${API_BASE_URL}/auth/patient_get_klinik/${user?.user?.klinik_id}`;
            }else{
                url = `${API_BASE_URL}/auth/pos/patient_data/${data?.klinik_id}/${data?.no_medical_record}/${data?.no_regist}`;
            }
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if (!response.ok) {
                setDataPatient({
                    status: false,
                    data: [],
                    message: 'Failed to fetch data',
                    code: 404
                });
                return;
            }
            const datas = await response.json();
            
            setDataPatient({
                status: true,
                data: datas || [],
                message: 'Success',
                code: 200
            });
            return;
        } catch (error) {
            setDataPatient({
                status: false,
                data: [],
                message: 'Failed to fetch data',
                code: 500
            });
        }
    }, [location.state,user,data]);

    const categoryTreatment = useCallback( async () => {
        try {
            // const token = localStorage.getItem('access_token');
            const token = user?.token;
            // fetch data category treatment
            const response = await fetch(`${API_BASE_URL}/auth/pos/treatment-categories?klinik_id=${data?.klinik_id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if (!response.ok) {
                setCategoryTreatmentData({
                    status: false,
                    data: [],
                    message: 'Failed to fetch data',
                    code: 404
                });
                return;
            }
            const datas = await response.json();
            setCategoryTreatmentData({
                status: true,
                data: datas.data || [],
                message: 'Success',
                code: 200
            });
            return;

        } catch (error) {
            setCategoryTreatmentData({
                status: false,
                data: [],
                message: 'Failed to fetch data',
                code: 500
            });
        }
    }, [data,user]);

    const categoryProduct = useCallback( async () => {
        try {
            const token = user?.token;
            const response = await fetch(`${API_BASE_URL}/auth/pos/products-categories?klinik_id=${data?.klinik_id}&group_id=1`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if (!response.ok) {
                setCategoryProductData({
                    status: false,
                    data: [],
                    message: 'Failed to fetch data',
                    code: 404
                });
                return;
            }
            const datas = await response.json();
            setCategoryProductData({
                status: true,
                data: datas.data || [],
                message: 'Success',
                code: 200
            });
            return;
        } catch (error) {
            setCategoryProductData({
                status: false,
                data: [],
                message: 'Failed to fetch data',
                code: 500
            });
        }
    }, [data,user]);

    const categoryObat = useCallback( async () => {
        try {
            const token = user?.token;
            const response = await fetch(`${API_BASE_URL}/auth/pos/products-categories?klinik_id=${data?.klinik_id}&group_id=2`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if (!response.ok) {
                setCategoryObatData({
                    status: false,
                    data: [],
                    message: 'Failed to fetch data',
                    code: 404
                });
                return;
            }
            const datas = await response.json();
            setCategoryObatData({
                status: true,
                data: datas.data || [],
                message: 'Success',
                code: 200
            });
            return;
        } catch (error) {
            setCategoryObatData({
                status: false,
                data: [],
                message: 'Failed to fetch data',
                code: 500
            });
        }
    }, [data,user]);

    const therapisList = useCallback( async () => {
        try {
            const token = user?.token;
            const response = await fetch(`${API_BASE_URL}/auth/employee_get_klinik/${data?.klinik_id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if (!response.ok) {
                setTherapisOpt([]);
            }
            const datas = await response.json();
            const options = datas.data.filter(emp => emp.role === 3).map(emp => ({
                value: emp.id,
                label: emp.full_name
            }));
            setTherapisOpt(options);
            return;
        }catch (error) {
            setTherapisOpt([]);
        }
    }, [data,user]);

    const dokterList = useCallback( async () => {
        try {
            const token = user?.token;
            const response = await fetch(`${API_BASE_URL}/auth/employee_get_klinik/${data?.klinik_id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if (!response.ok) {
                setDokterOpt([]);
            }
            const datas = await response.json();
            const options = datas.data.filter(emp => emp.role === 1).map(emp => ({
                value: emp.id,
                label: emp.full_name
            }));
            setDokterOpt(options);
            return;
        }catch (error) {
            setDokterOpt([]);
        }
    }, [data,user]);

    useEffect(() => {
        setLoadingCategory(true); // mulai loader
        Promise.all([
            headerPatient(),
            categoryTreatment(),
            categoryProduct(),
            categoryObat(),
            therapisList(),
            dokterList(),
        ]).finally(() => {
            setLoadingCategory(false); // selesai loader
        });
    }, [headerPatient,categoryTreatment,categoryProduct,categoryObat,therapisList,dokterList]);

    useEffect(() => {
        if (location.state && Array.isArray(savedDoctorReview) && savedDoctorReview.length > 0) {
            const mappedOrderItems = savedDoctorReview.flatMap(item => {
                if (item.type === 'package') {
                    return item.details.map(pkgItem => ({
                        id: pkgItem.id,
                        no_medical_record: item.no_medical_record,
                        klinik_id: item.klinik_id,
                        no_regist: item.no_regist,
                        package_id: item.package_id,
                        treatment_id: pkgItem.id,
                        quantity: pkgItem.category === 'treatment' ? ( pkgItem.quantity * item.qty ) : ( pkgItem.minimum_stok * item.qty),
                        unit_price: pkgItem.category === 'treatment' ? pkgItem.unit_price : pkgItem.unit_price,
                        price: pkgItem.category === 'treatment' ? pkgItem.price : pkgItem.price,
                        discount_type: item.discount_type,
                        discount_value: item.discount_value,
                        final_price: pkgItem.category === 'treatment' ? (pkgItem.final_price * item.qty) : (pkgItem.final_price * item.qty),
                        created_at: item.created_at,
                        updated_at: item.updated_at,
                        created_by: item.created_by,
                        type: pkgItem.category,
                        item_id: pkgItem.id || null,
                        status_bayar: null,
                        name: pkgItem.name || 'Unknown Treatment',
                        quantity_real: pkgItem.category === 'treatment' ? pkgItem.quantity : pkgItem.minimum_stok,
                        description: pkgItem.description || '',
                        duration: pkgItem.duration || 0,
                        doctor_commission_type: pkgItem.doctor_commission_type || 0,
                        doctor_commission_value: pkgItem.doctor_commission_value || 0,
                        therapist_commission_value: pkgItem.therapist_commission_value || 0,
                        therapist_commission_type: pkgItem.therapist_commission_type || 0,
                    }));
                } else if(item.type === 'treatment' || item.type === 'product' || item.type === 'medicine') {
                    return [{
                        id: item.id,
                        no_medical_record: item.no_medical_record,
                        klinik_id: item.klinik_id,
                        no_regist: item.no_regist,
                        package_id: item.package_id,
                        treatment_id: item.type === 'treatment' ? item.treatment_id : item.product_id,
                        quantity: item.type === 'treatment' ? item.qty : item.quantity,
                        unit_price: item.type === 'treatment' ? item.unit_price : item.details.unit_price,
                        price: item.type === 'treatment' ? item.unit_price : item.details.price,
                        discount_type: item.discount_type,
                        discount_value: item.discount_value,
                        final_price: item.type === 'treatment' ? item.final_price : (item.details.price * item.quantity),
                        created_at: item.created_at,
                        updated_at: item.updated_at,
                        created_by: item.created_by,
                        type: item.type,
                        item_id: item.details?.id || null,
                        status_bayar: null,
                        name: item.details?.name || 'Unknown Treatment',
                        quantity_real: item.details?.quantity || 1 ,
                        description: item.details?.description || '',
                        duration: item.details?.duration || 0,
                        doctor_commission_type: item.details?.doctor_commission_type || 0,
                        doctor_commission_value: item.details?.doctor_commission_value || 0,
                        therapist_commission_value: item.details?.therapist_commission_value || 0,
                        therapist_commission_type: item.details?.therapist_commission_type || 0,
                    }];
                }
                return [];
            });
            const saved = localStorage.getItem("orderItems");
            if (saved) {
                let initialValue = JSON.parse(saved) || [];
                let combinedItems = [...initialValue, ...mappedOrderItems];
                let uniqueItems = combinedItems.filter(
                    (item, idx, arr) => arr.findIndex(i => i.id === item.id) === idx
                );
                setOrderItems(uniqueItems);
            } else {
                setOrderItems(mappedOrderItems);
            }
        }
    }, [data, location.state, savedDoctorReview]);

    useEffect(() => {
        localStorage.setItem('orderItems', JSON.stringify(orderItems));
    }, [orderItems]);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            // Tampilkan alert konfirmasi
            e.preventDefault();
            e.returnValue = 'Data worker akan hilang jika Anda reload halaman ini. Lanjutkan?';

            // Hapus data worker dari localStorage setelah reload benar-benar terjadi
            window.addEventListener('unload', () => {
                localStorage.removeItem('workers');
                localStorage.removeItem('orderItems');
                localStorage.removeItem('patients');
            }, { once: true });
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    },[]);

    const formatRupiah = (number) => {
        return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(number);
    };

    function DepositHistoryModal({ show, handleClose, depositHistory }) {
        // Pagination logic
        const [page, setPage] = useState(1);
        const pageSize = 10;
        const totalData = depositHistory ? depositHistory.length : 0;
        const totalPages = Math.ceil(totalData / pageSize);
        const pagedData = depositHistory ? depositHistory.slice((page - 1) * pageSize, page * pageSize) : [];

        return (
            <ModalInfo
                handleClose={handleClose}
                title={'Riwayat Deposit'}
                content={
                    <>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Tanggal</th>
                                        <th>Nominal</th>
                                        <th>Keterangan</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {depositHistory && depositHistory.length === 0 ? (
                                        <tr><td colSpan={3} className="text-center">Tidak ada riwayat deposit</td></tr>
                                    ) : (
                                        (pagedData || []).map((item, idx) => (
                                            <tr key={idx}>
                                                <td>{item.created_at ? new Date(item.created_at).toLocaleDateString('id-ID') : '-'}</td>
                                                <td>{item.amount ? `Rp. ${Number(item.amount).toLocaleString('id-ID')}` : '-'}</td>
                                                <td>{item.notes || '-'}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {totalPages > 1 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <button className="btn btn-sm btn-light" disabled={page === 1} onClick={() => setPage(page - 1)}>
                                    &lt; Prev
                                </button>
                                <span>Halaman {page} dari {totalPages}</span>
                                <button className="btn btn-sm btn-light" disabled={page === totalPages} onClick={() => setPage(page + 1)}>
                                    Next &gt;
                                </button>
                            </div>
                        )}
                    </>
                }
            />
        );
    }

    const HeaderPos = () => { 
        return (
            <>
                <div className='col-lg-3 col-sm-12 p-3'>
                    <CardBasic
                        className={'h-100'}
                        className2={'p-9'}
                    >
                        <h5 className='fs-1hx fw-bold'>
                            Data Patient
                        </h5>
                        <div className='fs-6 fw-semibold text-gray-400 mb-7'>
                            <span>Latest social statistics</span>
                        </div>
                        <div className='fs-7 d-flex justify-content-between mb-4'>
                            <div className='fw-semibold'>{ location.state ? dataPatient?.data?.data?.patient?.full_name : pasien.full_name }</div>
                        </div>
                        <div className="separator separator-dashed"></div>
                        <div className='fs-7 d-flex justify-content-between mb-4'>
                            <div className='fw-semibold'>{ location.state ? dataPatient?.data?.data?.patient?.no_medical_record : pasien.no_medical_record }</div>
                        </div>
                        <div className="separator separator-dashed"></div>
                        <div className='fs-7 d-flex justify-content-between mb-4'>
                            <div className='fw-semibold'>{ '-' }</div>
                        </div>
                    </CardBasic>
                </div>
                <div className='col-lg-3 col-sm-12 p-3'>
                    <CardBasic
                        className={'h-100'}
                        className2={'p-9'}
                    >
                        <h5 className='fs-1hx fw-bold'>
                            Packages
                        </h5>
                        <div className='fs-6 fw-semibold text-gray-400 mb-7'>
                            <span>Latest social statistics</span>
                        </div>
                        <div className="separator separator-dashed mb-4"></div>
                            {
                              dataPatient?.status === true && 
                              ( location.state ? Array.isArray(dataPatient?.data?.data?.package) && dataPatient?.data?.data?.package.length > 0 : Array.isArray(pasien?.data?.package) && pasien?.data?.package.length > 0 )
                                ? ( location.state ? 
                                        dataPatient.data.data.package.map((item, index) => (
                                        <div key={index} >
                                            <div className='fs-6 d-flex justify-content-between align-items-center mb-4'>
                                                <div className='fw-semibold fs-8'>{item?.treatment?.treatment_name ?? ''}</div>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <div className="d-flex fw-bold me-1">{item?.used_qty}/{item?.total_qty}</div>
                                                    <button className='btn btn-sm btn-outline-primary btn-light-primary'
                                                    onClick={() => {
                                                        setOrderItems(prev => {
                                                            // Cek apakah sudah ada di orderItems
                                                            const exist = prev.find(i => i.item_id === item.treatment.id);
                                                            if (exist) return prev;
                                                            return [...prev, {
                                                                ...item.treatment,
                                                                type: 'treatment',
                                                                name: item.treatment.treatment_name,
                                                                treatment_id: item.treatment.id,
                                                                item_id: item.treatment.id,
                                                                quantity_real: item.treatment.quantity || 1,
                                                                unit_price: 0,
                                                                price: item.treatment.base_price,
                                                                final_price: 0,
                                                                no_medical_record: item.patient.no_medical_record || null,
                                                                no_regist: item.no_regist || null,
                                                                klinik_id: item.patient.klinik_id || null,
                                                                quantity: 1,
                                                                used_qty: 1,
                                                                // tambahkan properti lain sesuai kebutuhan
                                                            }];
                                                        });
                                                    }}
                                                    >Use</button>
                                                </div>
                                            </div>
                                            <div className="separator separator-dashed"></div>
                                        </div>
                                        ))
                                :
                                        pasien.data.package.map((item, index) => (
                                            <div key={index} >
                                                <div className='fs-6 d-flex justify-content-between align-items-center mb-4'>
                                                    <div className='fw-semibold fs-8'>{item?.treatment?.treatment_name ?? ''}</div>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <div className="d-flex fw-bold me-1">{item?.used_qty}/{item?.total_qty}</div>
                                                        <button className='btn btn-sm btn-outline-primary btn-light-primary'
                                                        onClick={() => {
                                                            setOrderItems(prev => {
                                                                // Cek apakah sudah ada di orderItems
                                                                const exist = prev.find(i => i.item_id === item.treatment.id);
                                                                if (exist) return prev;
                                                                return [...prev, {
                                                                    ...item.treatment,
                                                                    name: item.treatment.treatment_name,
                                                                    package_id: null,
                                                                    type: 'treatment',
                                                                    treatment_id: item.treatment.id,
                                                                    item_id: item.treatment.id,
                                                                    quantity: 1,
                                                                    quantity_real: item.treatment.quantity || 1,
                                                                    unit_price: 0,
                                                                    final_price: 0,
                                                                    price: item.treatment.base_price,
                                                                    no_medical_record: data?.no_medical_record || pasien?.no_medical_record || null,
                                                                    no_regist: data?.no_regist || null,
                                                                    klinik_id: data?.klinik_id || null,
                                                                    used_qty: 1
                                                                    // tambahkan properti lain sesuai kebutuhan
                                                                }];
                                                            });
                                                        }}
                                                        >Use</button>
                                                    </div>
                                                </div>
                                                <div className="separator separator-dashed"></div>
                                            </div>
                                        )
                                    )
                                )
                                : <span className='text-gray-400'>No active package</span>
                            }
                    </CardBasic>
                </div>
                <div className='col-lg-3 col-sm-12 p-3'>
                    <CardBasic
                        className={'h-100'}
                        className2={'p-9'}
                        children={''}
                    >
                        <h5 className='fs-1hx fw-bold'>
                            Notes
                        </h5>
                        <div className='fs-7 fw-semibold text-gray-400 mb-7'>
                            <span>Notes from Doctor</span>
                        </div>
                        <div className="separator separator-dashed mb-4"></div>
                        {
                            dataPatient?.status === true  && 
                            ( location.state ? dataPatient?.data?.data?.notes != null : pasien?.data?.notes != null ) ? (
                                location.state ? 
                                    <div>
                                        <div className='fs-7 d-flex justify-content-between mb-4'>
                                            <div className='fw-bold'>{dataPatient?.data?.data?.notes?.doctor_name || 'No Doctor Assigned'}</div>
                                        </div>
                                        <div className='fs-7 d-flex justify-content-between mb-4'>
                                            <div className='fw-semibold'>{dataPatient?.data?.data?.notes?.notes || 'No Doctor Assigned'}</div>
                                        </div>
                                    </div>
                                :
                                    <div>
                                        <div className='fs-7 d-flex justify-content-between mb-4'>
                                            <div className='fw-bold'>{pasien.data.notes?.doctor_name || 'No Doctor Assigned'}</div>
                                        </div>
                                        <div className='fs-7 d-flex justify-content-between mb-4'>
                                            <div className='fw-semibold'>{pasien.data.notes?.notes || 'No Doctor Assigned'}</div>
                                        </div>
                                    </div>
                            )
                          : <span className='text-gray-400'>No notes available</span>
                        }
                     
                    </CardBasic>
                </div>
                <div className='col-lg-3 col-sm-12 p-3'>
                    <CardBasic
                        className={'h-100'}
                        className2={'p-9'}
                        children={''}
                    >
                        <h5 className='fs-1hx fw-bold'>
                            Credit/Deposit
                        </h5>
                        <div className='fs-6 fw-semibold text-gray-400 mb-7'>
                            <span>Credit logs or Deposit logs</span>
                        </div>
                        <div className="separator separator-dashed mb-4"></div>
                        {
                            dataPatient?.status === true && 
                            ( location.state ? dataPatient?.data?.data?.deposit != null : pasien?.data?.deposit != null ) 
                                ? (location.state ?
                                    <div className='fs-6 d-flex justify-content-between align-items-center mb-4'>
                                        <div className='fw-semibold text-success'>{`Rp. ${Number(dataPatient.data.data.total_deposit).toLocaleString('id-ID')}`}</div>
                                        <button className='btn btn-sm btn-outline-success btn-light-success' onClick={() => {
                                            setShowDepositHistoryModal(true);
                                            setDepositHistory(dataPatient.data.data.deposit || []);
                                        }}>Riwayat</button>
                                    </div>
                                    :   
                                    <div className='fs-6 d-flex justify-content-between align-items-center mb-4'>
                                        <div className='fw-semibold text-success'>{`Rp. ${Number(pasien.data.total_deposit).toLocaleString('id-ID')}`}</div>
                                        <button className='btn btn-sm btn-outline-success btn-light-success' onClick={() => {
                                            setShowDepositHistoryModal(true);
                                            setDepositHistory(pasien.data.deposit || []);
                                        }}>Riwayat</button>
                                    </div>
                                )
                                : <span className='text-gray-400'>No Deposit available</span>
                        }
                    </CardBasic>
                </div>
            </>
        )
    }

    const ListPos = ({ orderItems, setOrderItems, categoryTreatmentData, categoryProductData, categoryObatData }) => {
        const [activeTab, setActiveTab] = useState('treatment');

        //search
        const [searchTreatment, setSearchTreatment] = useState('');
        const [searchProduct, setSearchProduct] = useState('');
        const [searchObat, setSearchObat] = useState('');

        const [selectedTab, setSelectedTab] = useState('');

        useEffect(() => {
            if (activeTab === 'treatment' && categoryTreatmentData.status && categoryTreatmentData.data.length > 0) {
                setSelectedTab(categoryTreatmentData.data[0].id);
            }
            if (activeTab === 'product' && categoryProductData.status && categoryProductData.data.length > 0) {
                setSelectedTab(categoryProductData.data[0].id);
            }
            if (activeTab === 'obat' && categoryObatData.status && categoryObatData.data.length > 0) {
                setSelectedTab(categoryObatData.data[0].id);
            }
        }, [activeTab,categoryTreatmentData,categoryProductData,categoryObatData]);

        const visibleCount = 4;
        const [startIdx, setStartIdx] = useState(0);

        const handlePrev = () => {
            setStartIdx((prev) => Math.max(prev - visibleCount, 0));
        };

        const handleNext = () => {
            setStartIdx((prev) =>
                Math.min(prev + visibleCount, categoryTreatmentData?.data?.length - visibleCount)
            );
        };

        const handleSearchChange = (e) => {
            setSearchTreatment(e.target.value);
            setSearchProduct(e.target.value);
            setSearchObat(e.target.value);
        };

        return (
            <>
                <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-6 fw-semibold mb-8" 
                    style={{ background: 'transparent', borderBottom: 'none' }}>
                   <li className="nav-item">
                        <button
                            className={`nav-link text-active-primary pb-4 ${activeTab === 'treatment' ? 'active' : ''}`}
                            onClick={() => setActiveTab('treatment')}
                            style={{ background: 'transparent' }}
                        >
                            Treatment
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link text-active-primary pb-4 ${activeTab === 'product' ? 'active' : ''}`}
                            onClick={() => setActiveTab('product')}
                            style={{ background: 'transparent' }}
                        >
                            Product
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link text-active-primary pb-4 ${activeTab === 'obat' ? 'active' : ''}`}
                            onClick={() => setActiveTab('obat')}
                            style={{ background: 'transparent' }}
                        >
                            Obat
                        </button>
                    </li>
                </ul>
                <div className="tab-content py-4">
                    {activeTab === 'treatment' && (
                        <div>
                            <div className="d-flex align-items-center position-relative my-1 mb-5">
                                <i className="ki-outline ki-magnifier fs-3 position-absolute ms-4"></i>
                                <TextInput 
                                    type={'text'} 
                                    clas={'form-control form-control-solid w-100 ps-12'}
                                    placeholder={'Search Treatment...'}
                                    value={searchTreatment}
                                    onChange={handleSearchChange}
                                />
                            </div>
                            <div className='d-flex flex-row flex-wrap justify-content-center gap-4'>
                                <button
                                    className="btn btn-transparent me-2"
                                    onClick={handlePrev}
                                    disabled={startIdx === 0}
                                    style={{ height: 200 }}
                                >
                                &lt;
                                </button>
                                {categoryTreatmentData?.data?.slice(startIdx, startIdx + visibleCount).map((item) => (   
                                    <TabCard
                                        key={item.id}
                                        assetImg={item.thumbnail !== null && item.thumbnail !== '' ? item.thumbnail : Health}
                                        title={item.name}
                                        subtitle={item.treatments.length + ' Items'}
                                        width={'138px'}
                                        height={'180px'}
                                        active={selectedTab === item.id}
                                        onClick={() => setSelectedTab(item.id)}
                                    />
                                ))}
                                <button
                                    className="btn btn-transparent ms-2"
                                    onClick={handleNext}
                                    disabled={startIdx + visibleCount >= categoryTreatmentData?.data?.length}
                                    style={{ height: 200 }}
                                >
                                &gt;
                                </button>
                            </div>
                            <div className="d-flex justify-content-center mt-4 gap-2">
                                <span
                                    style={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    display: 'inline-block',
                                    background: startIdx === 0 ? '#2563eb' : '#e5e7eb', // biru jika di awal
                                    }}
                                ></span>
                                <span
                                    style={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    display: 'inline-block',
                                    background: startIdx === visibleCount ? '#2563eb' : '#e5e7eb', // biru jika di kedua
                                    }}
                                ></span>
                            </div>
                            <div className='tab-content mt-5'>
                                <div className={`tab-pane fade show active`}>
                                    <div className="d-flex flex-wrap d-grid gap-5 gap-xxl-9 justify-content-center">
                                     
                                        {Array.isArray(categoryTreatmentData.data) &&
                                        categoryTreatmentData.data
                                        .find(cat => cat.id === selectedTab)?.treatments?.map(item => (
                                            
                                            <CardBasic
                                            key={item.id}
                                            className={'card-flush p-6 pb-5 flex-row-fluid'}
                                            className2={'text-center'}
                                            style={{ maxWidth: '250px', width: '100%' }}
                                            >
                                                <Image
                                                    src={item.thumbnail !== null && item.thumbnail !== '' ? item.thumbnail : Health}
                                                    className="rounded-3 mb-4"
                                                    style={{
                                                    width: '70%',
                                                    height: 'auto',
                                                    maxWidth: '150px',
                                                    margin: '0 auto',
                                                    display: 'block'
                                                    }}
                                                    alt={item.name}
                                                />
                                                <div className="mb-2">
                                                    <div className="text-center">
                                                        <span
                                                            className="fw-bold text-gray-800 cursor-pointer text-hover-primary"
                                                            style={{
                                                            fontSize: 'clamp(1rem, 1vw, 1.3rem)',
                                                            display: 'block',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            width: '100%'
                                                            }}
                                                            onClick={(e) => {
                                                                if (item.type === 'package' && Array.isArray(item.details) && item.details.length > 0) {
                                                                    e.stopPropagation();
                                                                    setOrderItems(prev => {
                                                                        // Masukkan setiap detail sebagai item order
                                                                        let newOrder = [...prev];
                                                                        item.details.forEach(detail => {
                                                                            // const exist = newOrder.find(i => i.id === detail.id);
                                                                            const idx = newOrder.findIndex(i => i.id === detail.treatment_id);
                                                                            if (idx !== -1) {
                                                                                // newOrder = newOrder.map(i =>
                                                                                //     i.id === detail.id
                                                                                //         ? { ...i, quantity: i.quantity + (detail.quantity || 1) }
                                                                                //         : i
                                                                                // );
                                                                                newOrder[idx] = {
                                                                                    ...newOrder[idx],
                                                                                    quantity: newOrder[idx].quantity + (detail.quantity || 1)
                                                                                };
                                                                            } else {
                                                                                newOrder.push({
                                                                                    ...detail,
                                                                                    package_id: item.id,
                                                                                    treatment_id: detail.details_id,
                                                                                    item_id: detail.details_id,
                                                                                    quantity: detail.quantity || 1,
                                                                                    quantity_real: detail.quantity || 1,
                                                                                    name: detail.name,
                                                                                    final_price: detail.final_price,
                                                                                    unit_price: detail.unit_price,
                                                                                    price: detail.price,
                                                                                    thumbnail: item.thumbnail, // atau detail.thumbnail jika ada
                                                                                    type: detail.category,
                                                                                    no_registration: data?.no_regist || null,
                                                                                    klinik_id: user?.user?.klinik_id || null,
                                                                                    no_medical_record: data?.no_medical_record || pasien?.no_medical_record || null,
                                                                                    used_qty: 1
                                                                                });
                                                                            }
                                                                        });
                                                                        return newOrder;
                                                                    });
                                                                } else {
                                                                    // Treatment biasa
                                                                    e.stopPropagation();
                                                                    setOrderItems(prev => {
                                                                        const exist = prev.find(i => i.id === item.id);
                                                                        if (exist) {
                                                                            return prev.map(i =>
                                                                                i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i
                                                                            );
                                                                        }
                                                                        return [
                                                                            ...prev,
                                                                            {
                                                                                ...item,
                                                                                package_id: null,
                                                                                type: 'treatment',
                                                                                treatment_id: item.id,
                                                                                item_id: item.id,
                                                                                quantity: 1,
                                                                                quantity_real: item.quantity || 1,
                                                                                unit_price: item.unit_price,
                                                                                no_medical_record: data?.no_medical_record || pasien?.no_medical_record || null,
                                                                                no_regist: data?.no_regist || null,
                                                                                klinik_id: data?.klinik_id || null,
                                                                                used_qty: 1
                                                                            }
                                                                        ];
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            {item.name}
                                                        </span>
                                                        <span className="text-gray-400 fw-semibold d-block mt-n1"
                                                            style={{
                                                            fontSize: 'clamp(0.8rem, 1vw, 1rem)',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            width: '100%'
                                                            }}
                                                        >{item.description}</span>
                                                    </div>
                                                </div>
                                                <span className="text-success text-end fw-bold"
                                                    style={{ fontSize: 'clamp(1rem, 2vw, 1.5rem)' }}
                                                >Rp. {formatRupiah(item.final_price ?? item.price)}</span>
                                            </CardBasic>
                                            
                                        ))
                                        }
                                        {categoryTreatmentData.data &&
                                            categoryTreatmentData.data.find(cat => cat.id === selectedTab)?.treatments.length === 0 && (
                                            <div className="text-muted text-center w-100 py-5">Tidak ada data treatment untuk kategori ini.</div>
                                        )}
                                        
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    )}
                    {activeTab === 'product' && (
                    <div>
                        <div className="d-flex align-items-center position-relative my-1 mb-5">
                            <i className="ki-outline ki-magnifier fs-3 position-absolute ms-4"></i>
                            <TextInput 
                            type={'text'} 
                            clas={'form-control form-control-solid w-100 ps-12'}
                            placeholder={'Search Product...'}
                            value={searchProduct}
                            onChange={handleSearchChange}
                            />
                        </div>
                        <div className='d-flex flex-row flex-wrap justify-content-center gap-4'>
                                <button
                                    className="btn btn-transparent me-2"
                                    onClick={handlePrev}
                                    disabled={startIdx === 0}
                                    style={{ height: 200 }}
                                >
                                &lt;
                                </button>
                                {categoryProductData?.data?.slice(startIdx, startIdx + visibleCount).map((item) => (   
                                    <TabCard
                                        key={item.id}
                                        assetImg={item.thumbnail !== null && item.thumbnail !== '' ? item.thumbnail : Health}
                                        title={item.name}
                                        subtitle={item.products.length + ' Items'}
                                        width={'138px'}
                                        height={'180px'}
                                        active={selectedTab === item.id}
                                        onClick={() => setSelectedTab(item.id)}
                                    />
                                ))}
                                <button
                                    className="btn btn-transparent ms-2"
                                    onClick={handleNext}
                                    disabled={startIdx + visibleCount >= categoryProductData?.data?.length}
                                    style={{ height: 200 }}
                                >
                                &gt;
                                </button>
                        </div>
                        <div className="d-flex justify-content-center mt-4 gap-2">
                            <span
                                style={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                display: 'inline-block',
                                background: startIdx === 0 ? '#2563eb' : '#e5e7eb', // biru jika di awal
                                }}
                            ></span>
                            <span
                                style={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                display: 'inline-block',
                                background: startIdx === visibleCount ? '#2563eb' : '#e5e7eb', // biru jika di kedua
                                }}
                            ></span>
                        </div>
                        <div className='tab-content mt-5'>
                            <div className={`tab-pane fade show active`}>
                                <div className="d-flex flex-wrap d-grid gap-5 gap-xxl-9 justify-content-center">
                                    {Array.isArray(categoryProductData.data) &&
                                    categoryProductData.data
                                    .find(cat => cat.id === selectedTab)?.products?.map(item => (
                                        <CardBasic
                                        key={item.id}
                                        className={'card-flush p-6 pb-5 flex-row-fluid'}
                                        className2={'text-center'}
                                        style={{ maxWidth: '250px', width: '100%' }}
                                        >
                                            <Image
                                                src={item.thumbnail !== null && item.thumbnail !== '' ? item.thumbnail : Health}
                                                className="rounded-3 mb-4"
                                                style={{
                                                width: '70%',
                                                height: 'auto',
                                                maxWidth: '150px',
                                                margin: '0 auto',
                                                display: 'block'
                                                }}
                                                alt={item.name}
                                            />
                                            <div className="mb-2">
                                                <div className="text-center">
                                                    <span
                                                        className="fw-bold text-gray-800 cursor-pointer text-hover-primary"
                                                        style={{
                                                        fontSize: 'clamp(1rem, 1vw, 1.3rem)',
                                                        display: 'block',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        width: '100%'
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setOrderItems(prev => {
                                                                const exist = prev.find(i => i.id === item.id);
                                                                if (exist) {
                                                                return prev.map(i =>
                                                                    i.id === item.id ? { ...i, quantity: i.quantity + 1, used_qty: i.used_qty } : i
                                                                );
                                                                }
                                                                return [...prev, { ...item,
                                                                    type: 'product',
                                                                    quantity: 1, 
                                                                    quantity_real: item.quantity, 
                                                                    unit_price: item.unit_price,
                                                                    used_qty: 1 ,
                                                                    item_id: item.id,
                                                                    no_medical_record: data?.no_medical_record || pasien?.no_medical_record || null,
                                                                    no_regist: data?.no_regist || null,
                                                                    klinik_id: data?.klinik_id || null
                                                                }];
                                                            });
                                                        }}
                                                    >
                                                        {item.name}
                                                    </span>
                                                    <span className="text-gray-400 fw-semibold d-block mt-n1"
                                                        style={{
                                                        fontSize: 'clamp(0.8rem, 1vw, 1rem)',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        width: '100%'
                                                        }}
                                                    >{item.description}</span>
                                                </div>
                                            </div>
                                            <span className="text-success text-end fw-bold"
                                                style={{ fontSize: 'clamp(1rem, 2vw, 1.5rem)' }}
                                            >Rp. {formatRupiah(item.final_price ?? item.price)}</span>
                                        </CardBasic>
                                        
                                    ))
                                    }
                                    {categoryProductData.data &&
                                        categoryProductData.data.find(cat => cat.id === selectedTab)?.products.length === 0 && (
                                        <div className="text-muted text-center w-100 py-5">Tidak ada data produk untuk kategori ini.</div>
                                    )}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                    {activeTab === 'obat' && (
                    <div>
                        <div className="d-flex align-items-center position-relative my-1 mb-5">
                            <i className="ki-outline ki-magnifier fs-3 position-absolute ms-4"></i>
                            <TextInput 
                            type={'text'} 
                            clas={'form-control form-control-solid w-100 ps-12'}
                            placeholder={'Search Obat...'}
                            value={searchObat}
                            onChange={handleSearchChange}
                            />
                        </div>
                        <div className='d-flex flex-row flex-wrap justify-content-center gap-4'>
                                <button
                                    className="btn btn-transparent me-2"
                                    onClick={handlePrev}
                                    disabled={startIdx === 0}
                                    style={{ height: 200 }}
                                >
                                &lt;
                                </button>
                                {categoryObatData?.data?.slice(startIdx, startIdx + visibleCount).map((item) => (   
                                    <TabCard
                                        key={item.id}
                                        assetImg={item.thumbnail !== null && item.thumbnail !== '' ? item.thumbnail : Health}
                                        title={item.name}
                                        subtitle={item.products.length + ' Items'}
                                        width={'138px'}
                                        height={'180px'}
                                        active={selectedTab === item.id}
                                        onClick={() => setSelectedTab(item.id)}
                                    />
                                ))}
                                <button
                                    className="btn btn-transparent ms-2"
                                    onClick={handleNext}
                                    disabled={startIdx + visibleCount >= categoryObatData?.data?.length}
                                    style={{ height: 200 }}
                                >
                                &gt;
                                </button>
                        </div>
                        <div className="d-flex justify-content-center mt-4 gap-2">
                            <span
                                style={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                display: 'inline-block',
                                background: startIdx === 0 ? '#2563eb' : '#e5e7eb', // biru jika di awal
                                }}
                            ></span>
                            <span
                                style={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                display: 'inline-block',
                                background: startIdx === visibleCount ? '#2563eb' : '#e5e7eb', // biru jika di kedua
                                }}
                            ></span>
                        </div>
                        <div className='tab-content mt-5'>
                            <div className={`tab-pane fade show active`}>
                                <div className="d-flex flex-wrap d-grid gap-5 gap-xxl-9 justify-content-center">
                                    {Array.isArray(categoryObatData.data) &&
                                    categoryObatData.data
                                    .find(cat => cat.id === selectedTab)?.products?.map(item => (
                                        <CardBasic
                                        key={item.id}
                                        className={'card-flush p-6 pb-5 flex-row-fluid'}
                                        className2={'text-center'}
                                        style={{ maxWidth: '250px', width: '100%' }}
                                        >
                                            <Image
                                                src={item.thumbnail !== null && item.thumbnail !== '' ? item.thumbnail : Health}
                                                className="rounded-3 mb-4"
                                                style={{
                                                width: '70%',
                                                height: 'auto',
                                                maxWidth: '150px',
                                                margin: '0 auto',
                                                display: 'block'
                                                }}
                                                alt={item.name}
                                            />
                                            <div className="mb-2">
                                                <div className="text-center">
                                                    <span
                                                        className="fw-bold text-gray-800 cursor-pointer text-hover-primary"
                                                        style={{
                                                        fontSize: 'clamp(1rem, 1vw, 1.3rem)',
                                                        display: 'block',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        width: '100%'
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setOrderItems(prev => {
                                                                const exist = prev.find(i => i.id === item.id);
                                                                if (exist) {
                                                                return prev.map(i =>
                                                                    i.id === item.id ? { ...i, quantity: i.quantity + 1, used_qty: i.used_qty } : i
                                                                );
                                                                }
                                                                return [...prev, { ...item,
                                                                    type: 'medicine',
                                                                    quantity: 1,
                                                                    quantity_real: item.quantity,
                                                                    unit_price: item.unit_price,
                                                                    used_qty: 1,
                                                                    no_medical_record: data?.no_medical_record || pasien?.no_medical_record || null,
                                                                    no_regist: data?.no_regist || null,
                                                                    klinik_id: data?.klinik_id || null,
                                                                    item_id: item.id,
                                                                }];
                                                            });
                                                        }}
                                                    >
                                                        {item.name}
                                                    </span>
                                                    <span className="text-gray-400 fw-semibold d-block mt-n1"
                                                        style={{
                                                        fontSize: 'clamp(0.8rem, 1vw, 1rem)',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        width: '100%'
                                                        }}
                                                    >{item.description}</span>
                                                </div>
                                            </div>
                                            <span className="text-success text-end fw-bold"
                                                style={{ fontSize: 'clamp(1rem, 2vw, 1.5rem)' }}
                                            >Rp. {formatRupiah(item.final_price ?? item.price)}</span>
                                        </CardBasic>
                                        
                                    ))
                                    }
                                    {categoryObatData.data &&
                                        categoryObatData.data.find(cat => cat.id === selectedTab)?.products.length === 0 && (
                                        <div className="text-muted text-center w-100 py-5">Tidak ada data produk untuk kategori ini.</div>
                                    )}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </>
        )
    }

    const CardCheckout = ({ orderItems, setOrderItems }) => {
        const handleCheckout = () => {
            const workers = JSON.parse(localStorage.getItem('workers')) || [];
            const items = JSON.parse(localStorage.getItem('orderItems')) || [];

            //cek pasien
            const cekPatient = location.state ? dataPatient?.data?.data : pasien?.data?.patient;
            if(cekPatient === undefined || cekPatient === null){
                setShowAlert(true);
                setAlertType("danger");
                setAlertMessage("Belum bisa melanjutkan proses, pasien harus ditambahkan!");
                return;
            }

            //cek order item
            if(items.length === 0){
                setShowAlert(true);
                setAlertType("danger");
                setAlertMessage("Belum bisa melanjutkan proses, item order masih kosong!");
                return;
            }

            // Cek apakah semua orderItems sudah punya worker
            const allHaveWorker = orderItems.every(order =>
                workers.some(worker => worker.order && worker.order.id === order.id)
            );
            
            if (!allHaveWorker) {
                setShowAlert(true);
                setAlertType("danger");
                setAlertMessage("Belum bisa melanjutkan proses, semua item harus ada worker-nya!");
                return;
            }
            if(location.state === null){
                if(pasien.length === 0){
                    setShowAlert(true);
                    setAlertType("danger");
                    setAlertMessage("Belum bisa melanjutkan proses, pasien harus ditambahkan!");
                    return;
                }
            }

            const patientReal = location.state ? dataPatient.data.data : pasien.data;
            const path = location.state ? 'Registration' : 'Cashier';
            localStorage.setItem('patients', JSON.stringify(patientReal));
            navigate('checkout', {
                state: { ...data }
            });
        };

        const handleQtyChange = (id, delta) => {
            setOrderItems(prev =>{
                const updated = prev.map(item =>
                item.id === id ?
                 { ...item, quantity: item.quantity + delta, final_price: item.price * (item.quantity + delta) } 
                 : item
                 ).filter(item => item.quantity > 0);

                const workers = JSON.parse(localStorage.getItem('workers')) || [];
                if(workers.length > 0){
                    const newWorkers = workers.map(worker => {
                        if (worker.order && worker.order.id === id) {
                            const newQty = updated.find(i => i.id === id)?.quantity || 1;
                            return {
                            ...worker,
                            order: {
                                ...worker.order,
                                quantity: newQty,
                                final_price: (worker.order.price ?? worker.order.final_price) * newQty
                            }
                            };
                        }
                        return worker;
                    });
                    localStorage.setItem('workers', JSON.stringify(newWorkers));
                }
                    localStorage.setItem('orderItems', JSON.stringify(updated));

                return updated;
            });
        };

        const handleClearAll = () => {
            localStorage.removeItem('workers');
            localStorage.removeItem('orderItems');
            setOrderItems([])
        };

        const subtotal = orderItems.reduce((sum, item) => sum + item.unit_price * item.quantity, 0);
        const discount = 0; // implementasi diskon sesuai kebutuhan
        // const tax = Math.round(subtotal * 0.12);
        const total = subtotal - discount;

        return (
            <>
                <div className='flex-row-auto w-xl-425px mt-8'>
                    <CardBasic
                        className={'card-flush bg-body'}
                        className3={'pt-5'}
                        className2={'pt-0'}
                        header={
                            <div className='align-items-center' style={{ display: 'contents'}}>
                                <h3 className='card-title fw-bold text-gray-800 fs-4 mb-0'>Current Order</h3>
                                <div className='card-toolbar'>
                                    <button className='btn btn-light-primary fs-5 fw-bold py-3' onClick={handleClearAll}>Clear All</button>
                                </div>
                            </div>
                        }
                    >
                        <div className='table-responsive mb-8'>
                            <table className='table align-middle gs-0 gy-4 my-0'>
                                <thead>
                                    <tr>
                                        <th className="min-w-175px"></th>
                                        <th className="w-125px"></th>
                                        <th className="w-60px"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderItems.length === 0 ? (
                                        <tr>
                                        <td colSpan={3} className="text-center text-muted">Belum ada order</td>
                                        </tr>
                                    ) : (
                                        orderItems.map(item => (
                                        <tr key={item.id}>
                                            <td className='pe-0'>
                                            <div className='d-flex align-items-center'>
                                                <Image
                                                src={item.thumbnail && item.thumbnail !== null && item.thumbnail !== '' ? item.thumbnail : Health}
                                                className="w-30px h-30px rounded-3 me-3"
                                                alt={item.name}
                                                />
                                                <span className='fw-bold text-gray-800 fs-6 me-1 cursor-pointer text-hover-primary'
                                                style={{ textDecoration: 'underline' }}
                                                onClick={() => {
                                                    handleModalWorker(item);
                                                    setSelectedOrderItem(item);
                                                }}
                                                >{item.name}</span>
                                            </div>
                                            </td>
                                            <td className="pe-0">
                                            <div className='position-relative d-flex align-items-center'>
                                                <button type="button" className="btn btn-icon btn-sm btn-light btn-icon-gray-400"
                                                onClick={() => handleQtyChange(item.id, -1)}>
                                                <i className="ki-outline ki-minus fs-1x"></i>
                                                </button>
                                                <input type="text" className="form-control border-0 text-center px-0 fs-3 fw-bold text-gray-800 w-30px" readOnly value={item.quantity} />
                                                <button type="button" className="btn btn-icon btn-sm btn-light btn-icon-gray-400"
                                                onClick={() => handleQtyChange(item.id, 1)}>
                                                <i className="ki-outline ki-plus fs-1x"></i>
                                                </button>
                                            </div>
                                            </td>
                                            <td className="text-end">
                                            <span className="fw-bold text-primary fs-6">{formatRupiah(item.unit_price * item.quantity)}</span>
                                            </td>
                                        </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className='d-flex flex-stack bg-success rounded-3 p-6 mb-11'>
                            <div className='fs-6 fw-bold text-white'>
                                <span className="d-block lh-1 mb-2">Subtotal</span>
                                <span className="d-block mb-2">Discounts</span>
                                <span className="d-block mb-9">Tax(12%)</span>
                                <span className="d-block fs-2qx lh-1">Total</span>
                            </div>
                            <div className="fs-6 fw-bold text-white text-end">
                                <span className="d-block lh-1 mb-2" data-kt-pos-element="total">{formatRupiah(subtotal)}</span>
                                <span className="d-block mb-2" data-kt-pos-element="discount">{formatRupiah(-discount)}</span>
                                <span className="d-block mb-9" data-kt-pos-element="tax">0</span>
                                <span className="d-block fs-2qx lh-1" data-kt-pos-element="grant-total">{formatRupiah(total)}</span>
                            </div>
                        </div>
                        <div className="m-0">
                            <SButton
                                variant={'primary'}
                                size={'sm'}
                                className={'btn-primary fs-1 w-100 py-4'}
                                type={'button'}
                                action={handleCheckout}      
                            >
                                Checkout
                            </SButton>
                        </div>
                    </CardBasic>
                </div>
            </>
        )
    }

    const handleModal = () => {
        setFields(
                [
                    { type: 'hidden', name: '_id', label: '_ids',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'autocomplete', name: 'name', label: 'Full Name',classLabel: 'form-label' ,placeholder: 'Input your full name..', value: '', className: '',disable: false,required: true, data: dataPatient?.data?.data || []},
                    { type: 'hidden', name: 'no_medical_record', label: 'No. Medical Record',classLabel: 'form-label' ,placeholder: '', value: dataPatient?.data?.data?.no_medical_record || '', className: '',disable: false,required: false},
                    { type: 'text', name: 'handphone', label: 'No. Telp', classLabel: 'form-label',value: '', className: '',disable: false,required: true, onlyNumber: true,column: 'col-6'},
                    { type: 'text', name: 'email', label: 'Email',classLabel: 'form-label' , placeholder: 'Input your email...', value: '', className: '',disable: false,required: true,column: 'col-6' },
                ]
        
        )
        setShowModal(true);
    }

    const handleModalWorker = (orderItem) => {
        // jika orderItem diteruskan, set selectedOrderItem agar data tersedia
        if (orderItem) setSelectedOrderItem(orderItem);
        const item = orderItem || selectedOrderItem || {};

        const savedWorkers = JSON.parse(localStorage.getItem('workers')) || [];
        const initialForm = savedWorkers.find(
            w => w.order && w.order.id === item.id
        );
        
        const price = Number(item.price ?? item.final_price ?? 0);
        const unit_price = Number(item.unit_price ?? price);
        const qty = Number(item.quantity ?? 1);
        const basePrice = unit_price * qty || 0;
        const basePriceValue = initialForm?.order?.final_price ?? basePrice;

    
        setFields(
                [
                    { type: 'hidden', name: '_id', label: '_ids',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'text', name: 'base_price', label: 'Base Price',classLabel: 'form-label' ,placeholder: 'Input base price..', value: basePriceValue, className: '',onlyNumber: true,disable: false,required: true},
                    {
                        type: 'radio',
                        name: 'discount_type',
                        label: 'Discount Type',
                        classLabel: 'form-label',
                        options: [
                            { label: 'No Discount', value: 'none' },
                            { label: 'Percentage %', value: 'percentage' },
                            { label: 'Fixed Price', value: 'fixed' }
                        ],
                        value: initialForm?.discount_type ? initialForm.discount_type : 'none',
                        className: '',
                        disable: false,
                        required: true,
                        row: true
                    },
                    { type: 'number', name: 'discount', label: 'Discount', classLabel: 'form-label', placeholder: '0', value: initialForm?.discount ?? 0, className: '', min: 0, disable: false, required: true, onlyNumber: true },
                    {
                        type: 'select',
                        name: 'therapist',
                        label: 'Therapist',
                        classLabel: 'form-label',
                        placeholder: 'Select therapist',
                        value: initialForm?.therapist ?? '',
                        className: '',
                        disable: false,
                        required: true,
                        column: 'col-6',
                        options: therapisOpt // isi dengan data therapist dari API jika ada
                    },
                    {
                        type: 'select',
                        name: 'doctor',
                        label: 'Doctor',
                        classLabel: 'form-label',
                        placeholder: 'Select doctor',
                        value: initialForm?.doctor ?? '',
                        className: '',
                        disable: false,
                        required: true,
                        column: 'col-6',
                        options: dokterOpt // isi dengan data doctor dari API jika ada
                    },
                    {
                        type: 'textarea',
                        name: 'notes',
                        label: 'Notes/Deskripsi',
                        classLabel: 'form-label',
                        placeholder: 'Notes/Deskripsi',
                        value: initialForm?.notes ?? '',
                        className: '',
                        disable: false,
                        required: false
                    },
                ]

        )
        setShowAddWorkerModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSaveModal = async (formData) => {
        setLoadingModal(true);
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_BASE_URL}/auth/pos/patient_data/${data?.klinik_id}/${formData.no_medical_record}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if(!response.ok){
                throw new Error('Network response was not ok');
            }
            const result = await response.json();
            setPasien({
                data: result.data,
                no_medical_record: formData.no_medical_record,
                full_name: formData.name,
                email: formData.email,
                phone: formData.handphone
            });
            const order = localStorage.getItem("orderItems");
            if(order){
                const parsedOrder = JSON.parse(order);
                const updatedOrder = parsedOrder.map(item => ({ 
                    ...item,
                    no_medical_record: formData.no_medical_record,
                }));
                localStorage.setItem('orderItems', JSON.stringify(updatedOrder));
            }
            setShowAlert(true);
            setAlertMessage("Patient berhasil ditambahkan!");
            setAlertType("success");
        } catch (error) {
            console.error('Error fetching patient data:', error);
            setPasien([]);
            setShowAlert(true);
            setAlertMessage("Gagal mengambil data pasien!");
            setAlertType("danger");
        } finally {
            setLoadingModal(false);
            // setShowModal(false);
        }
    }

    const handleSaveWorker = (formData) => {
        const patientReal = location.state ? dataPatient?.data?.data : pasien?.data?.patient;
        if(patientReal === undefined || patientReal === null){
            setShowAlert(true);
            setAlertType("danger");
            setAlertMessage("Belum bisa menambahkan worker, pasien harus ditambahkan!");
            return;
        }
        const workerData = {
            ...formData,
            order : { ...selectedOrderItem, discount: formData.discount || 0, discount_type: formData.discount_type || 'none' },
            patient: { ...patientReal }
        };
       
        const prevWorkers = JSON.parse(localStorage.getItem('workers')) || [];
        // Cek apakah sudah ada worker untuk order yang sama (berdasarkan order.id)
        const filteredWorkers = prevWorkers.filter(
            w => !(w.order && w.order.id === selectedOrderItem.id)
        );

        // Tambahkan/replace dengan worker baru
        const newWorkers = [...filteredWorkers, workerData];
     
        // Simpan kembali ke localStorage
        localStorage.setItem('workers', JSON.stringify(newWorkers));
        setShowAddWorkerModal(false);
        setShowAlert(true);
        setAlertMessage("Worker berhasil ditambahkan!");
        setAlertType("success");
    }

  return (
    <>
        <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Breadcrumb title={'Home'} header={'POS System'} />
            <div className='app-container container-xxl d-flex'>
                <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                    <div className='d-flex flex-column flex-column-fluid'>
                        <div className='app-content'>
                            <div className='d-flex justify-content-end me-3'>
                                <SButton
                                    className={'btn-light-primary me-3'}
                                    variant={'light-primary'}
                                    size={'sm'}
                                    action={() => {
                                        if (fromRegistration) {
                                            localStorage.removeItem('workers');
                                            localStorage.removeItem('orderItems');
                                            localStorage.removeItem('patients');
                                            navigate('/registration'); // ganti dengan path halaman registration kamu
                                        } else {
                                            localStorage.removeItem('workers');
                                            localStorage.removeItem('orderItems');
                                            localStorage.removeItem('patients');
                                            navigate(-1); // kembali ke halaman sebelumnya
                                        }
                                    }}
                                >
                                    <i className="ki-outline ki-arrow-left fs-2 me-1"></i>
                                    Back
                                </SButton>
                                
                                <SButton
                                    className={'btn-primary'}
                                    variant={'primary'}
                                    size={'sm'}
                                    action={handleModal}
                                    disabled={fromRegistration}
                                >
                                    Add Patient
                                </SButton>
                            </div>
                            <div className='d-flex flex-wrap'>
                                <HeaderPos />
                            </div>
                            {loadingCategory ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <span className="ms-3">Memuat kategori...</span>
                                    </div>
                                ) : (
                                <div className="d-flex m-lg-5 mb-10 mb-lg-0 gap-4">
                                    <div style={{ flex: 2 }}>
                                        <ListPos orderItems={orderItems} 
                                        setOrderItems={setOrderItems} 
                                        categoryTreatmentData={categoryTreatmentData}
                                        categoryProductData={categoryProductData}
                                        categoryObatData={categoryObatData}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <CardCheckout orderItems={orderItems} setOrderItems={setOrderItems}/>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='app-footer d-flex flex-column flex-md-row flex-center flex-md-stack pb-3'>
                        <div className='text-dark order-2 order-md-1'>
                            <span className='text-muted fw-semibold me-1'>2025&copy;</span>
                        </div>
                        <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
                            <li className='menu-item'><span className='menu-link px-2'>About</span></li>
                            <li className='menu-item'><span className='menu-link px-2'>Support</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        {showModal && (
            <ModalForm
                show={showModal}
                handleClose={handleCloseModal}
                formDatas={fields}
                title={'Add Patient'}
                handleSave={handleSaveModal}
                loading={loadingModal}
            />
        )}
        {showDepositHistoryModal && (
            <DepositHistoryModal
                show={showDepositHistoryModal}
                handleClose={() => setShowDepositHistoryModal(false)}
                depositHistory={depositHistory}
            />
        )}
        {
            showAddWorkerModal && (
                <ModalForm
                    show={showAddWorkerModal}
                    handleClose={() => setShowAddWorkerModal(false)}
                    formDatas={fields}
                    data={selectedOrderItem}
                    title={'Add Worker'}
                    handleSave={handleSaveWorker}
                />
            )
        }
        {
            showAlert && (
                <ShowAlert
                    title="OK"
                    message={alertMessage}
                    svg={alertType === 'success' ? 'svg-icon-success' : 'svg-icon-danger'}
                    show={showAlert}
                    setShow={setShowAlert}
                    swal={alertType === 'success' ? 'swal2-success' : 'swal2-error'}
                />
            )
        }
       
    </>
  )
}

export default Pos;